import {Component, DestroyRef, inject, Signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {filter} from 'rxjs';
import {NavigationEnd, NavigationStart, Router, RouterOutlet} from '@angular/router';
import {ModalComponent, SnackbarComponent, SpinnerComponent, TagIconComponent} from '@tecalisdev/infinity';
import {LanguageService} from '@core/services/language.service';
import {StorageKeys} from '@core/constants/constants';
import {LoadingService} from '@shared/services/loading.service';
import {MasterService} from '@core/services/master.service';
import {ErrorService} from '@core/services/error.service';
import {ILoading} from '@shared/models/loading.models';
import {SnackbarService} from '@shared/services/snackbar.service';
import {DialogConfirmationService} from '@shared/services/dialog-confirmation.service';
import {ISnackbar} from '@shared/models/snackbar.models';
import {IModalConfirmation} from '@shared/models/modal-confirmation.models';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '@env/environment';
import {ThemeBootstrapService} from '@core/services/theme-bootstrap.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
	imports: [
		ModalComponent,
		SnackbarComponent,
		SpinnerComponent,
		TagIconComponent,
		RouterOutlet
	]
})
export class AppComponent {
	private languageService = inject(LanguageService);
	private loadingService = inject(LoadingService);
	private themeBootstrap = inject(ThemeBootstrapService);
	private router = inject(Router);
	private masterService = inject(MasterService);
	private errorService = inject(ErrorService);
	private destroyRef = inject(DestroyRef);
	private trans = inject(TranslateService);
	public snackbarService = inject(SnackbarService);
	public dialogConfirmationService = inject(DialogConfirmationService);

	public loading: Signal<ILoading>;
	public loadingMaster: Signal<ILoading>;
	public snackbar: Signal<ISnackbar>;
	public modalConfirmation: Signal<IModalConfirmation>;
	/** Asset del spinner desde Apariencia (tema); vacío = Infinity nativo. */
	public readonly spinnerImg = this.themeBootstrap.spinnerUrl;
	private currentUrl: string;

	constructor() {
		document.documentElement.classList.add(`provider-${environment.provider}`);
		this.languageService.autoResolveLanguage();
		this.loading = this.loadingService.loading;
		this.loadingMaster = this.loadingService.loadingMaster;
		this.snackbar = this.snackbarService.snackbar;
		this.modalConfirmation = this.dialogConfirmationService.dialogConfirmation;

		if (localStorage.getItem(StorageKeys.ACCESS_TOKEN)) {
			this.loadingService.showMaster(this.trans.instant('LOADING.USER'));
		}

		this.router.events.pipe(
			filter((event) => event instanceof NavigationStart),
			takeUntilDestroyed(this.destroyRef)
		).subscribe(() => {
			if (this.errorService.generalError().show) {
				this.errorService.hideGeneralError();
			}
		});

		this.router.events.pipe(
			filter((event) => event instanceof NavigationEnd),
			takeUntilDestroyed(this.destroyRef)
		).subscribe((event: NavigationEnd) => {
			const previousUrl = this.currentUrl;
			this.currentUrl = event.url;
			this.masterService.setPreviousUrl(previousUrl);
		});
	}

}
